import type { HTMLAttributes, ReactNode, TdHTMLAttributes, ThHTMLAttributes } from "react";
import { cx } from "../../lib/cx.js";

/**
 * Tabla densa. El contenedor desplaza en horizontal DENTRO de sí mismo: la página
 * nunca se desborda en móvil aunque la tabla tenga muchas columnas.
 */
export function Table({ caption, children, className }: { caption?: string; children: ReactNode; className?: string }) {
  return (
    // relative: los textos sr-only (absolutos) de celdas desplazadas no deben ensanchar la página.
    <div className={cx("relative w-full overflow-x-auto", className)}>
      <table className="w-full border-collapse text-left text-[13px]">
        {caption && <caption className="sr-only">{caption}</caption>}
        {children}
      </table>
    </div>
  );
}

export function THead({ children }: { children: ReactNode }) {
  return <thead className="border-b border-border bg-surface-2 text-[12px] text-muted">{children}</thead>;
}

export function TH({ className, children, ...rest }: ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th scope="col" className={cx("px-3 py-2 font-semibold whitespace-nowrap", className)} {...rest}>
      {children}
    </th>
  );
}

export function TR({ className, children, ...rest }: HTMLAttributes<HTMLTableRowElement>) {
  return (
    <tr className={cx("border-b border-border last:border-b-0", className)} {...rest}>
      {children}
    </tr>
  );
}

export function TD({ className, children, ...rest }: TdHTMLAttributes<HTMLTableCellElement>) {
  return (
    <td className={cx("px-3 py-2 align-top", className)} {...rest}>
      {children}
    </td>
  );
}
